import { Channels } from 'generated-graphql/types';

// A hidden or disabled checkbox submits null (= inherit the org setting),
// never false — false is an explicit opt-out the user didn't make.
export const getEmailFallbackSubmitValue = ({
  channel,
  emailChannelFallbackEnabled,
  isEmailFallbackDisabled
}: {
  channel: Channels | null;
  emailChannelFallbackEnabled: boolean | null;
  isEmailFallbackDisabled: boolean;
}): boolean | null =>
  (channel === Channels.Whatsapp || channel === Channels.Sms) &&
  !isEmailFallbackDisabled
    ? emailChannelFallbackEnabled
    : null;
